'use client';

import { createContext } from 'react';
var pageContext = /*#__PURE__*/createContext(null);
export default pageContext;